module.exports = __webpack_public_path__ + "img/phone.74f49633.png";